import { styled, Tab, Tabs, Theme } from '@mui/material';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '&.MuiTabs-root': {
    border: theme.spacing(0),
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    marginLeft: '-2px',
  },
}));

export const StyledDistrictWideComparisonsTabs = styled(Tab)(({ theme }) => ({
  '&.MuiTab-root': {
    '&.MuiButtonBase-root': {
      backgroundColor: theme.palette.customGrey.adminButtonBorder,
      padding: theme.spacing(0, 4, 0, 2),
      margin: theme.spacing(0, 2, 0, 0.15),
      borderRadius: theme.spacing(1.5, 1.5, 0, 0),
      color: theme.palette.fontColors.fontBlack,
      textTransform: 'none',
    },
    '& .tag': {
      display: 'inline-block',
      backgroundColor: theme.palette.customWhite.main,
      width: theme.spacing(5),
      marginRight: theme.spacing(1),
      borderRadius: theme.spacing(1.35),
      color: theme.palette.fontColors.fontBlack,
      fontWeight: 'bold',
    },
    '&.schools': {
      '& .tag': {
        backgroundColor: theme.palette.customWhite.main,
        color: theme.palette.fontColors.fontBlack,
      },
    },
    '&.grades': {
      '& .tag': {
        backgroundColor: theme.palette.customWhite.main,
        color: theme.palette.fontColors.fontBlack,
      },
    },
    '&.Mui-selected': {
      '&.MuiButtonBase-root': {
        backgroundColor: theme.palette.customBlue.primaryBlue,
        color: theme.palette.customWhite.main,
      },
      '&.schools': {
        '& .tag': {
          backgroundColor: theme.palette.customWhite.main,
          color: theme.palette.fontColors.fontBlack,
        },
      },
      '&.grades': {
        '& .tag': {
          backgroundColor: theme.palette.customWhite.main,
          color: theme.palette.fontColors.fontBlack,
        },
      },
    },
  },
}));

export const DistrictWideComparisonsStylesCSS = (theme: Theme) => ({
  dashBoardContainer: {
    padding: theme.spacing(2, 2, 2, 1),
  },
  width5: {
    width: '5%',
  },
  width10: {
    width: '10%',
  },
  width15: {
    width: '15%',
  },
  width20: {
    width: '20%',
  },
  width25: {
    width: '25%',
  },
  width30: {
    width: '30%',
  },
  width35: {
    width: '35%',
  },
  tableContainer: {
    border: `2px solid ${theme.palette.customBlue.primaryBlue}`,
    borderTop: 'none',
    borderRadius: theme.spacing(0, 1.5, 1.5, 1.5),
    backgroundColor: theme.palette.customWhite.main,
  },
  tableRowBorder: {
    borderBottom: `1px solid ${theme.palette.customGrey.adminButtonBorder}`,
  },
  tableRowHover: {
    '&:focus, &:hover': {
      backgroundColor: theme.palette.customGrey.adminButtonBorder,
    },
  },
  tableRowEven: {
    backgroundColor: theme.palette.customBackground.dragBackground,
  },
  tableCellTextAlignLeft: {
    '&.MuiTableCell-root':{
      textAlign: 'left',
    },
  },
  tableTypographyTextAlignLeft: {
    '&.MuiTypography-root':{
      textAlign: 'left',
    },
  },
  sliderTableContainer: {
    borderRadius: 0,
    border: 'none',
    height: '82vh',
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.customGrey.adminButtonBorder,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.customBlue.primaryBlue,
      borderRadius: 2,
    },
    overflowX: 'hidden',
  },
  drawerHeader: {
    width: '100%',
    height: theme.spacing(10),
    backgroundColor: theme.palette.customBlue.primaryBlue,
    color: theme.palette.customWhite.main,
    padding: theme.spacing(2),
  },
  drawerHeaderIcon: {
    color: theme.palette.customWhite.main,
    fontWeight: 'bold',
  },
  drawerTableColumn: {
    '&.MuiTableCell-root': {
      backgroundColor: theme.palette.customWhite.main,
      color: theme.palette.customBlack.dimmedBlack,
      top: '-8px',
    },
  },
  tag: {
    display: 'inline-block',
    width: theme.spacing(5),
    marginRight: theme.spacing(1),
    borderRadius: theme.spacing(1.35),
    fontWeight: 'bold',
  },
  tagDisabled: {
    backgroundColor: theme.palette.customGrey.adminButtonBorder,
    color: theme.palette.fontColors.fontBlack,
  },
  tagRed: {
    background: theme.palette.customRed.buttonFontRed,
    color: theme.palette.customWhite.main,
  },
  tagYellow: {
    background: theme.palette.customYellow.main,
    color: theme.palette.customBlack.fontBlack,
  },
  tagBlue: {
    background: theme.palette.customBlue.waterBlue,
    color: theme.palette.customWhite.main,
  },
  tagGreen: {
    background: theme.palette.customGreen.fontGreen,
    color: theme.palette.customWhite.main,
  },
  tagPurple: {
    background: theme.palette.customBlue.primaryBlue,
    color: theme.palette.customWhite.main,
  },
});
